if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSThemeConfig.custom.products_per_page,
            secondImageEnable: boostPFSThemeConfig.custom.second_image_enable,
			// Optional
			loadProductFirst: false,
			styleScrollToTop: 'style2',
			defaultDisplay: boostPFSThemeConfig.custom.layout,
			showPlaceholderProductList: true
		},
	};
}
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {  
        //console.log(this);
		if(!data) data = this.data;
      
        //console.log(data);
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/



		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);
        
		// Add Images      
		var aspect_ratio = '';
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
		itemImagesHtml += '<div class=" '+(boostPFSFilterConfig.general.secondImageEnable)+'" style="padding-top:';
		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
			itemImagesHtml += 1 / aspect_ratio * 100;
		} else {
			itemImagesHtml += 100;
		}
		itemImagesHtml += '%;">';
		// itemImagesHtml += '<img id="' + imgId + '" ' +
		// 	'class="grid-view-item__image lazyload" ' +
		// 	'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
		// 	'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
		// 	'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
		// 	'data-aspectratio="' + aspect_ratio + '" ' +
		// 	'data-sizes="auto" ' +
		// 	'alt="{{itemTitle}}">';
        itemImagesHtml += '<img id="' + imgId + '" ' +
			'class="grid-view-item__image lazyload" ' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'alt="{{itemTitle}}">';
        if(boostPFSFilterConfig.general.secondImageEnable != "") {
          if(images[1]) {
            itemImagesHtml += '<img class="secondary" alt="'+((images[1]['alt'] != null) ? (images[1]['alt']) : "" ) +'" src="'+Utils.optimizeImage(images[1]['src'], '600x600')+'">';
          }  
        }
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
		
        // Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}


		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

        //Add Variants
        itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
           
        var itemVariantHtml = ''; var variant_selected = '';var variant_id = data.variants[0].id;
        
        jQuery.getJSON(window.Shopify.routes.root+'products/'+data.handle+'.js', function(prod) {
          var firstVarient_unit_price = ( (prod.variants[0].unit_price) ? ( Shopify.formatMoney(prod.variants[0].unit_price)+( (prod.variants[0].unit_price_measurement.reference_unit) ? ( '/'+prod.variants[0].unit_price_measurement.reference_unit ) : "" ) ) : "" ); 
          jQuery('.cust_price-unit-price-'+prod.variants[0].id+' span[data-unit-price]').html(firstVarient_unit_price);
          for (var i = 0; i < prod['variants'].length; i++) {
            var variant_compare_at_price = (prod.variants[i].compare_at_price) ? Shopify.formatMoney(prod.variants[i].compare_at_price,  "{{amount}}") : 0;
            var variant_price            = (prod.variants[i].price) ? Shopify.formatMoney(prod.variants[i].price,  "{{amount}}") : 0;
            var variant_unit_price       = (prod.variants[i].unit_price) ? ( Shopify.formatMoney(prod.variants[i].unit_price)+( (prod.variants[i].unit_price_measurement.reference_unit) ? ( '/'+prod.variants[i].unit_price_measurement.reference_unit ) : "" ) ) : 0;
            var variant_discount         = (variant_compare_at_price > variant_price) ? Math.round((((variant_compare_at_price - variant_price)/variant_compare_at_price)*100).toFixed(2)) : 0;  
            if( variant_id == prod.variants[i].id )  {
              variant_selected = " selected";
            } else {
              variant_selected = "";
            }
            itemVariantHtml += '<span class="boost-custom-option'+ variant_selected +'" data_variant_img_src="'+ (prod.variants[i].featured_media?.preview_image.src) +'" data_variant_id="'+ (prod.variants[i].id) +'" data_price="'+ (variant_price) +'" data_unit_price="'+ (variant_unit_price) +'" data_comp_price="'+ (variant_compare_at_price) +'" data_discount="'+ (variant_discount) +'" data_availability="'+ (prod.variants[i].available) +'">'+ (prod.variants[i].title) +'</span>';
          }
          jQuery('.product_variants-'+prod.id).html(itemVariantHtml);
          // Boost 145222
          var variantId = variantAfterFilter(data);
          if (variantId !== '') {
            var element = jQ(`.boost-pfs-filter-products [data-id="${data.id}"] .product_variants-${data.id} [data_variant_id="${variantId}"]`);
            element.click();
          }
          // End Boost 145222
        });
        

        // Add first variant of product
        itemHtml = itemHtml.replace(/{{itemFirstVariant}}/g, data.variants[0].id);
        // Add to cart form
        itemHtml = itemHtml.replace(/{{itemAddToCartForm}}/g, buildAddtoCartForm(data));
        // Add soldOut label
		var itemSoldOutLabel = ''; var itemNotifyHtml = '';
        if(data.available) {
       // if(data.variants[0].available) {
    	  if( data.variants[0].compare_at_price != "" && data.variants[0].compare_at_price > data.variants[0].price ) {	
            itemSoldOutLabel = '<span class="sale-badge">'+boostPFSConfig.label.sale+'</span>';
          }
          itemNotifyHtml   = '<div class="product__notify-me" style="display:none;"><a href="'+(window.Shopify.routes.root+'products/'+data.handle)+'"> Benachrichtige Mich </a></div> '; 
        } else {
    		itemSoldOutLabel = '<span class="sold-out-badge">'+boostPFSConfig.label.sold_out+'</span>';
            itemNotifyHtml   = '<div class="product__notify-me"><a href="'+(window.Shopify.routes.root+'products/'+data.handle)+'"> Benachrichtige Mich </a></div> '; 
		}
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
        itemHtml = itemHtml.replace(/{{itemNotifyMe}}/g, itemNotifyHtml);
		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		//var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
        var onSale = (data.variants[0].compare_at_price) > (data.variants[0].price); // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
         
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

		return itemHtml;
	}

    
    // Build Add to Cart 
    function buildAddtoCartForm(data) {
      console.log(data);
      var addToCartHtml = '';
      if (data.variants[0].available) {
        addToCartHtml += '<div class="boost-pfs-actions">';
        addToCartHtml += '<form method="post" action="/cart/add" id="product_form-'+data.variants[0].id+'" enctype="multipart/form-data">';
        addToCartHtml += '<input type="hidden" name="quantity" value="1" min="1">';
        addToCartHtml += '<input type="hidden" name="varient-id" value="'+data.variants[0].id+'">';
        addToCartHtml += '<div class="boost-pfs-addtocart-wrapper">';
        addToCartHtml += '<button aria-label="Add To Cart" name="add" class="boost-pfs-addtocart-btn-collection">In den Warenkorb</button>';
        addToCartHtml += '</div>';
        addToCartHtml += '</form>';
        addToCartHtml += '</div>';
      }else{
        addToCartHtml += '<div class="boost-pfs-actions" style="display:none;">';
        addToCartHtml += '<form method="post" action="/cart/add" id="product_form-'+data.variants[0].id+'" enctype="multipart/form-data">';
        addToCartHtml += '<input type="hidden" name="quantity" value="1" min="1">';
        addToCartHtml += '<input type="hidden" name="varient-id" value="'+data.variants[0].id+'">';
        addToCartHtml += '<div class="boost-pfs-addtocart-wrapper">';
        addToCartHtml += '<button aria-label="Add To Cart" name="add" class="boost-pfs-addtocart-btn-collection">In den Warenkorb</button>';
        addToCartHtml += '</div>';
        addToCartHtml += '</form>';
        addToCartHtml += '</div>';
      }
      return addToCartHtml;
    }
  
	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
        var discountPer =  ( (data.variants[0].compare_at_price) > (data.variants[0].price) ) ? ( Math.round((((data.variants[0].compare_at_price - data.variants[0].price)/data.variants[0].compare_at_price)*100).toFixed(2)) ) : 0 ;
   
		priceHtml += '<dl class="price' + onSaleClass + ' price--unit-available" data-price>';
		if (boostPFSConfig.custom.vendor_enable) {
			priceHtml += '<div class="price__vendor">';
			priceHtml += '<dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt>';
			priceHtml += '<dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd>';
			priceHtml += '</div>';
		}
        
  //       priceHtml += '<div class="price__custom-regular-price">';
		// priceHtml += '<dt>';
		// priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		// priceHtml += '</dt>';
		// priceHtml += '<span class="price-item price-item--custom-regular" data-regular-price>' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) +'/kg</span>';
		// priceHtml += '</div>';
        priceHtml += '<div class="price__regular">';
        priceHtml += '<dt>';
        priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
        priceHtml += '</dt>';
        priceHtml += '<dd>';
        priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
        if (data.variants[0].compare_at_price != "" && data.variants[0].compare_at_price > data.variants[0].price) {
            priceHtml += Utils.formatMoney(data.variants[0].compare_at_price, Globals.moneyFormat);
        } //else {
            //priceHtml += Utils.formatMoney(data.variants[0].price, Globals.moneyFormat);
        //}
        priceHtml += '</span>';
        priceHtml += '</dd>';
        priceHtml += '</div>';
		priceHtml += '<div class="price__custom_sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.variants[0].price, Globals.moneyFormat);
		priceHtml += '</span> ';
  //       if(data.available) {
  //   	  if( data.variants[0].compare_at_price != "" && data.variants[0].compare_at_price > data.variants[0].price ) {	
  //           priceHtml += '<span class="price-item__label" aria-hidden="true">' + boostPFSConfig.label.sale + '</span>';
  //         }
  //       } else {
  //   		priceHtml += boostPFSConfig.label.sold_out;
		// }
		priceHtml += '</dd>';
		priceHtml += '</div>';
       
        
        priceHtml += '<div class="price__discount">';
        priceHtml += '<dd>';
        priceHtml += '<span class="price-item price-item--discount">';
        if(discountPer > 0) {
            priceHtml += (discountPer)+"% günstiger";
        }
        priceHtml += '</span> ';
        priceHtml += '</dd>';
        priceHtml += '</div>';
      
		priceHtml += '</dl>';

		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		// if (!totalProduct) totalProduct = this.totalProduct;
		// // Get page info
		// var currentPage = parseInt(Globals.queryParams.page);
		// var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// // If it has only one page, clear Pagination
		// if (totalPage <= 1) {
		// 	return '';
		// }

		// var paginationHtml = boostPFSTemplate.paginateHtml;

		// // Build Previous
		// var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		// previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		// paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// // Build Next
		// var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		// nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		// paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// // Build page items
		// //var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
  //       var count_of_current_showing_products = ( (currentPage*Globals.queryParams.limit) < totalProduct ) ? currentPage*Globals.queryParams.limit : totalProduct ;
		// var currentPage = "You've viewed "+(count_of_current_showing_products)+" of "+(totalProduct)+" Produkte";
  //       paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		// return paginationHtml;

        if (!totalProduct) totalProduct = this.totalProduct;
       // Get page info
       var currentPage = parseInt(Globals.queryParams.page);
       var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
       // If it has only one page, clear Pagination
       if (totalPage <= 1) {
         return '';
       }

       var paginationHtml = boostPFSTemplate.paginateHtml;
       // Build Previous
       var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
       previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
       paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
       // Build Next
       var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
       nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
       paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
       // Create page items array
       var beforeCurrentPageArr = [];
       for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
    	 beforeCurrentPageArr.unshift(iBefore);
       }
       if (currentPage - 4 > 0) {
    	   beforeCurrentPageArr.unshift('...');
       }
       if (currentPage - 4 >= 0) {
    	   beforeCurrentPageArr.unshift(1);
       }
       beforeCurrentPageArr.push(currentPage);
       var afterCurrentPageArr = [];
       for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
	   afterCurrentPageArr.push(iAfter);
       }
       if (currentPage + 3 < totalPage) {
       afterCurrentPageArr.push('...');
       }
       if (currentPage + 3 <= totalPage) {
       afterCurrentPageArr.push(totalPage);
       }
       // Build page items
       var pageItemsHtml = '';
       var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
       for (var iPage = 0; iPage < pageArr.length; iPage++) {
  	   if (pageArr[iPage] == '...') {
  	    pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
  	   } else {
	    pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
       }
       pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
       pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
       }
       var count_of_current_showing_products = ( (currentPage*Globals.queryParams.limit) < totalProduct ) ? currentPage*Globals.queryParams.limit : totalProduct ;
       var currentPageText = "You've viewed <span class='boost_pagination_progress_currentProducts'>"+(count_of_current_showing_products)+"</span> of <span class='boost_pagination_progress_totalProducts'>"+(totalProduct)+"</span> Produkte";
       paginationHtml = paginationHtml.replace(/{{pageItemsText}}/g, currentPageText);
      
       paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
       return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};

    // Boost 145222
    // Find variant after Filter 
    function variantAfterFilter(data) {
      var currentFilterOptionIds = [];
      Object.keys(Globals.queryParams).forEach(queryParam => {
          if (queryParam.startsWith(Globals.prefix)) {
              currentFilterOptionIds.push(queryParam);
          }
      });
      if (currentFilterOptionIds.length > 0) {
        var grosseFilter = currentFilterOptionIds.find(e => Globals.queryParams[e][0].indexOf('pfs-grosse:') !== -1);
        var grosseFilterValues = [];
        var grosseVariantId = '';
        
        var snacksToGo = ['10g','15g', '20g', '30g', '40g'];
        var dose = ['50g', '70g', '100g', '150g', '200g', '250g', '300g', '350g', '425g', '450g', '500g'];
        var vorratspackung = ['200g', '300g', '750g', '1000g', '1800g'];
        
        if (typeof grosseFilter !== 'undefined') {
          grosseFilterValues =  Globals.queryParams[grosseFilter]
          for (var gro = grosseFilterValues.length - 1; gro >= 0; gro--) { 
            var grosseValue = grosseFilterValues[gro];
          // for (var grosseValue of grosseFilterValues) {
            var isBreak = false;
            if (grosseValue === 'pfs-grosse:Snacks to go') {
              for (var variant of data.variants) {
                if (variant.merged_options)
                  var grosseData = variant.merged_options.find(e => e.indexOf('grosse:') !== -1);
                  var grosseName = grosseData.split('grosse:')[1];
                  var grosseValueArr = grosseName.split('x');
                  if(grosseValueArr.length > 1) {
                    if (snacksToGo.includes(grosseValueArr[1])) {
                      grosseVariantId = variant.id;
                      isBreak = true;
                      break;
                    }
                  } else {
                    if (snacksToGo.includes(grosseValueArr[0])) {
                      grosseVariantId = variant.id;
                      isBreak = true;
                      break;
                    }
                  }
              }
            } else if (grosseValue === 'pfs-grosse:Dose') {
              for (var variant of data.variants) {
                if (variant.merged_options)
                  var grosseData = variant.merged_options.find(e => e.indexOf('grosse:') !== -1);
                  var grosseName = grosseData.split('grosse:')[1];
                  var grosseValueArr = grosseName.split('x');
                  if(grosseValueArr.length > 1) {
                    if (dose.includes(grosseValueArr[1])) {
                      grosseVariantId = variant.id;
                      isBreak = true;
                      break;
                    }
                  } else {
                    if (dose.includes(grosseValueArr[0])) {
                      grosseVariantId = variant.id;
                      isBreak = true;
                      break;
                    }
                  }
              }
            } else if (grosseValue === 'pfs-grosse:Vorratspackung') {
              for (var variant of data.variants) {
                if (variant.merged_options)
                  var grosseData = variant.merged_options.find(e => e.indexOf('grosse:') !== -1);
                  var grosseName = grosseData.split('grosse:')[1];
                  var grosseValueArr = grosseName.split('x');
                  if(grosseValueArr.length > 1) {
                    if (vorratspackung.includes(grosseValueArr[1])) {
                      grosseVariantId = variant.id;
                      isBreak = true;
                      break;
                    }
                  } else {
                    if (vorratspackung.includes(grosseValueArr[0])) {
                      grosseVariantId = variant.id;
                      isBreak = true;
                      break;
                    }
                  }
              }
            }
            if (isBreak) break;
          }
        }
      }
      return grosseVariantId;
    }


  FilterApi.beforeCall = function(eventType, eventInfo) {
    // Code from Backend
    // if (product.tags.includes('B-Ware') && !product.available) {
    // 	 product.tags.push('pfs:hidden:hide');
    // }
        Globals.queryParams.h_options = ['hide'];
  }
  // End Boost 145222
})();